import React from "react";

import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./ShowMore.module.scss";

interface Props {
  className?: string;
  onClick?: () => void;
  right?: boolean;
}

const ShowMore: React.FC<Props> = ({ className, onClick, right = true }) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.button} onClick={onClick}>
        <FontAwesomeIcon className={styles.icon} icon={right ? faChevronRight : faChevronLeft} />
      </div>
    </div>
  );
};

export default ShowMore;
